import MessageApi from '../../../../api/inbox/message';

export default {
  async transcribeAudioMessage(
    { dispatch },
    { conversationId, messageId, attachmentId }
  ) {
    const { data } = await MessageApi.transcribeAudio(
      conversationId,
      messageId,
      attachmentId
    );
    await dispatch('updateMessage', data);
    return data;
  },
};
